import React, { ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import posthog from 'posthog-js'
import { useConfig } from '@web/walter-lib/config'
import { userApi } from '~api'

interface Props {
    children: ReactNode
}

const POSTHOG_KEY_1 = import.meta.env.VITE_POSTHOG_KEY_1
const POSTHOG_HOST_1 = import.meta.env.VITE_POSTHOG_HOST_1

if (POSTHOG_KEY_1 && POSTHOG_HOST_1) {
    posthog.init(POSTHOG_KEY_1, { api_host: POSTHOG_HOST_1 })
    window.isPosthogInit = true
}

window.posthog = posthog

export function PosthogLayer({ children }: Props) {
    const location = useLocation()
    const config = useConfig()
    const isAuth = Boolean(config?.userMeta?.isAuth)

    useEffect(() => {
        posthog?.capture('$pageview', { channel: 'retail_web' })
    }, [location])

    useEffect(() => {
        if (!window.isPosthogInit || !isAuth) {
            return
        }

        let shouldUpate = true

        const fetchUserDataAndIdentifyPosthog = async () => {
            try {
                const userData = await userApi.getUserInfo()

                if (userData.external_id && shouldUpate) {
                    // we should explicitly pass external_id as key in order to posthog to correctly display various users
                    window.posthog?.identify(userData?.external_id, { external_id: userData?.external_id })
                }
            } catch (error) {
                posthog?.capture('user data fetch error', {
                    message: 'Failed to fetch user data for posthog identification',
                    error,
                })
            }
        }

        fetchUserDataAndIdentifyPosthog()

        return () => {
            shouldUpate = false
        }
    }, [isAuth])

    return <>{children}</>
}
